import { IApplicationState } from '../../types/redux';
import { selectUser } from './selectUser';
import { IAuthUser } from '../../types/userData';

export const selectUserIsAgent = (state: IApplicationState) => {
  const user = selectUser(state);

  return Boolean((user as IAuthUser).isAgent);
};
